export default __webpack_public_path__ + "static/media/nodejs.9ab33389.svg";